import { render, staticRenderFns } from "./RotateSquare.vue?vue&type=template&id=9514f85c&scoped=true&"
import script from "./RotateSquare.vue?vue&type=script&lang=js&"
export * from "./RotateSquare.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare.vue?vue&type=style&index=0&id=9514f85c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9514f85c",
  null
  
)

export default component.exports